import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveMediaUrl } from "../lib/api";
import WatermarkedMedia from "./WatermarkedMedia";
import { ArrowRight } from "lucide-react";

export const BlogSection = ({ limit = 3 }) => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    api.getBlogs()
      .then((b) => setBlogs(b || []))
      .catch((err) => console.error("Failed to load blog section:", err));
  }, []);

  if (blogs.length === 0) return null;
  const list = blogs.slice(0, limit);

  return (
    <section id="blog" className="relative bg-onyx-900 py-24 md:py-32" data-testid="blog-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mb-14 flex items-end justify-between gap-4 flex-wrap">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-gold" />
              <span className="font-cinzel text-[11px] tracking-[0.4em] uppercase text-gold">
                The Journal
              </span>
            </div>
            <h2 className="font-bebas text-4xl md:text-6xl text-ivory leading-tight" data-testid="blog-title">
              Stories From The <span className="text-gold-gradient">Set</span>
            </h2>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 font-cinzel text-[10px] tracking-[0.3em] uppercase text-gold hover:text-gold-bright"
            data-testid="blog-view-all"
          >
            All Articles <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {list.map((b, i) => (
            <BlogCard key={b.id} blog={b} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const BlogCard = ({ blog, index }) => (
  <Link
    to={`/blog/${blog.slug}`}
    className="group gold-border bg-onyx-800 hover-lift overflow-hidden flex flex-col"
    data-testid={`blog-card-${index}`}
  >
    <div className="aspect-[16/10] overflow-hidden">
      <WatermarkedMedia
        src={blog.cover_url}
        alt={blog.title}
        position="bottom-right"
        opacity={0.8}
        watermarkSize={36}
        showCaption={false}
        className="h-full w-full transition-transform duration-700 group-hover:scale-105"
      />
    </div>
    <div className="p-6 flex-1 flex flex-col">
      <div className="flex flex-wrap gap-2 mb-3">
        {(blog.tags || []).slice(0, 3).map((t) => (
          <span
            key={t}
            className="font-cinzel text-[9px] tracking-[0.3em] uppercase text-gold border border-gold/30 px-2 py-0.5"
          >
            {t}
          </span>
        ))}
      </div>
      <h3 className="font-bebas text-2xl md:text-3xl text-ivory leading-tight group-hover:text-gold transition-colors">
        {blog.title}
      </h3>
      <p className="mt-3 text-ivory/60 text-sm leading-relaxed line-clamp-3">{blog.excerpt}</p>
      <div className="mt-5 flex items-center gap-2 text-gold text-xs font-cinzel tracking-[0.3em] uppercase">
        Read Story <ArrowRight size={12} />
      </div>
    </div>
  </Link>
);

export default BlogSection;
